import { Ramp, TopModelChildrenMerge } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import * as fields from './fields';
import { list } from './list';
var Mapper = function () {
    var showList = fields.logic.show.useShowList();
    return (React.createElement(React.Fragment, null, list.filter(function (_, index) { return showList[index]; }).map(function (column) { return (React.createElement(Ramp, { key: column, rampName: "DurabilityQuestionInput", column: column })); })));
};
export var Render = function (props) {
    var children = props.children;
    return (React.createElement(TopModelChildrenMerge, null,
        children,
        React.createElement(Mapper, null)));
};
